<template>
  <transition name="fade">
    <div v-show="show === 'loading'" class="page page0 loading">
      <div class="content">
        <div class="logo-wrap absolute-center">
          <p class="logo">. 正在加载 .</p>
          <div class="line-wrap relative">
            <div class="line" :style="{ width: percent }"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { mapState } from "vuex";
export default {
  name: "Loading",
  components: {},
  data() {
    return {
      percent: 0,
      images: [],
    };
  },
  methods: {
    nextPage() {
      this.$store.dispatch("setPageFn", "page1");
    },
    // 加载图片的方法
    getImg(aSrc, loadFn, callBack) {
      // 初始化的进度数
      let loadI = 0;
      // 统计页面图片总数
      const totalImg = aSrc.length;
      // 载入loading数据
      for (let i = 0; i < totalImg; i++) {
        // 创建一个图片对象
        const image = new Image();
        // 图片加载完毕时
        image.onload = function () {
          loadI++;
          const Scale = loadI / totalImg;
          const Percent = Math.floor(Scale * 100);
          loadFn && loadFn(Percent);
          // 当所有图片加载完毕时
          loadI === totalImg && callBack && callBack();
        };
        // 将获取到页面的图片路劲赋给刚创建的图片对象所在的src
        image.src = aSrc[i];
      }
    },
    loading() {
      const that = this;
      const path = require("path");
      //读取文件的路径 是否遍历文件的子目录 匹配文件正则表达式
      const files = require.context(
        "./images",
        false,
        /\.(png|jpg|gif|jpeg|webp|ico)$/
      );
      // files(key).default拿到该模块的vue对象
      files.keys().forEach((key) => {
        // console.log(key)
        const name = path.basename(key);
        this.images.push(require(`./images/${name}`));
      });
      // console.log(this.images.length)

      // 开始加载图片
      that.getImg(
        this.images,
        function (num) {
          that.percent = num + "%";
        },
        function () {
          setTimeout(function () {
            that.nextPage();
          }, 1000);
        }
      );
    },
  },
  computed: {
    ...mapState({
      show: "show",
    }),
  },
  mounted() {
    this.loading();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.loading {
  background: #fff;

  .logo-wrap {
    margin-top: -15%;
    width: 200px;
  }

  .logo {
    font-size: 26px;
    text-align: center;
    color: #ff4b00;
    margin-bottom: 20px;
  }

  .line-wrap {
    width: 100%;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    background: #bfc0c2;
  }

  .line {
    width: 100%;
    height: 100%;
    background: #ff4b00;
    -webkit-transition: all 0.5s linear;
    transition: all 0.5s linear;
  }
}
</style>
